let base = "https://www.uashub.cn/ketangApi" //   "http://192.168.1.54:8067"
let baseUrlTiKu = ""

let online_url = {
    // 登录部分
    apiLogin: base + '/client/checkLogin', //登录
    apiGetsms: base + '/client/checkRandRegisterGetSmsCode', //注册获取验证码 
    submit: base + '/client/checkRandRegister', //注册 
    apiForgetGetSms: base + '/client/checkRandForgetGetSmsCode',//忘记密码获取验证码
    fogetPwd: base + '/client/forgetPwd', //忘记密码

    // 首页部分
    apiGetBannerList: base + '/client/clientGetBannerList', // 获取轮播图
    apiGetIndexCourseList: base + '/client/clientGetIndexCourseList', //获取首页课程
    apiGetTeacherList: base + '/client/clientGetTeacherList', //查询名师列表
    apiGetNewsKind: base + '/client/clientGetNewsList', //资讯列表 - 根据分类查询资讯列表
    apiGetStudentWishList: base + '/client/clientGetIndexStudentMessageList', //学员列表 - 获取学员心声列表
    apiSaveStuWishVoice: base + '/client/clientAddStudentMessage', //学员列表 - 新增学员心声

    apiGetClassifyList: base + '/client/clientGetClassifyList', //分类列表 - 客户端查询分类列表
    apiGetCourseList: base + '/client/clientGetCourseList', //获取首页课程
    apiGetNewsAll: base + '/client/getNewsList', // 查全部资讯
    apiGetCourseListById: base +'/client/clientGetChapterListById', //课程 - 查询课程章节列表接口
    queryCourseDetailsById: base + '/client/clientGetCourseDescById', //根据课程id查询课程ß详情
    apiGetCourseCommentList: base + '/client/clientGetCourseCommentList', //课程列表 - 获取课程评论列表 
    apiCheckAuthorization: base + '/client/course/clienVideoCheckAuthorization', //播放视频鉴权
    apiGetNewsById: base + '/client/clientGetNewsById', //根据资讯id查询资讯详情
    apiToBuyCourse: base + '/client/student/clientBuyCouse',//购买课程
    getAuthCourseList: base + '/client/course/clientGetAuthorityCourseList', //我授权的课程列表  我的课程
    getMyMessageListReply: base + '/client/message/clientGetMyMessageListReply',//我的评论
    apiGetCourseComentReply: base + '/client/course/clientCourseCommentReply', //课程列表 - 评论回复列表
    apiClientMyCommentReply: base + '/client/message/clientMyCommentReply',//我的评论-回复评论
    apiClientGetStudentEn2Info: base + '/client/student/clientGetStudentEn2Info',//查询学员账号加密二账号密码
    apiGetNewsKindList: base + '/client/clientGetNewsCategoryList',//查询资讯分类




    

    apiCheckRandLogin: base + '/student/checkRandLogin',//手机验证码登录
    apiPhoneUpdate: base + '/student/phoneUpdatePwd',// 手机号修改密码
    apiGetStudentId: base + '/user/getStudentId/getStudentId', //获取学生id
    apiGetDefaultTopClassify: base + '/classify/clientGetDefaultTopClassify', //获取默认顶级分类
    apiGetAccountId: base + '/user/getAccountId/clientGetAccountId', //通过busi_id获取account_id
    getAccountConfig: base + '/account/user/clientGetAccountConfig',

    //精英名师
    apiGetTeacherById: base + '/teacher/queryTeacherById', //名师列表 - 根据老师Id查询老师详情,
    apiGetCollectTeacher: base + '/teacher/collectTeacher', //收藏/取消收藏老师

    //课程详情
    apiGetCouseById: base + '/course/clientQueryCourseById', //课程列表 - 查询课程详情
    apiGetCourseCollect: base + '/course/collectCourse', //收藏课程接口


    // 学员心声

    // 班级部分
    apiGetClassList: base + '/class/clientQueryClassList', //班级列表 - 查询班级列表
    apiGetClassCourseList: base + '/class/clientQueryClassCourseList', // 获取班级课程

    //1 关于我们 2 联系我们 3 用户协议
    apiGetUserAgreement: base + '/others/about/getUserAgreement', //获取关于我们

    //题库部分
    apiGetPaperList: baseUrlTiKu + '/tiku/student/clientGetPaperList', //客户端获取试题集列表
    apiPaperCheck: baseUrlTiKu + '/tiku/paperCheck/paperCheck', //试题集/试卷鉴权
    apiGetTestPaperQues: baseUrlTiKu + '/tiku/student/clientGetTestPaperQuestion', //客户端获取试卷试题列表
    apiCollectQues: baseUrlTiKu + '/tiku/student/collectQuestion', //收藏/取消收藏试题
    apiAnswerQues: baseUrlTiKu + '/tiku/question/answerQuestion', //习题做题提交接口 做一题交一题
    apiDailyPractice: baseUrlTiKu + '/tiku/student/dailyPractice', //获取每日一练试题
    apiGetCollectQuesList: baseUrlTiKu + '/tiku/student/getCollectQuestionList', //获取我收藏的试题列表
    apiGetpracticeRecords: baseUrlTiKu + '/tiku/student/getPracticeRecords', //获取练习记录
    saveExamPaperRecord: baseUrlTiKu + '/tiku/student/clientSaveExamPaperRecord', //创建考试记录
    clientGetTestPaperList: baseUrlTiKu + '/tiku/student/clientGetTestPaperList', //客户端获取试卷列表
    saveStuExamPaperRecord: baseUrlTiKu + '/tiku/student/saveStuExamPaperRecord', //添加学员考试做题记录
    getErrorQuestionPaper: baseUrlTiKu + '/tiku/errorQuestion/getErrorQuestionPaper', //获取错题试题集
    getErrorQuestion: baseUrlTiKu + '/tiku/errorQuestion/getErrorQuestion', //获取错误试题列表
    saveErrQuestionFeedback : baseUrlTiKu + '/tiku/question/saveErrQuestionFeedback', //添加错题反馈

    //个人中心
    getMyTeacher: base + '/teacher/myTeacher', // 收藏的老师
    getMycollectCourseList: base + '/course/myCollectCourse', //我收藏的课程
    getStuPlayVideoRecord: base + '/student/getStuPlayVideoRecord', //获取学员视频观看记录
}

export default online_url